export { rsLatin } from '@payloadcms/translations/languages/rsLatin'
